/** Colunas do order by da pesquisa dos tipos de arquivos */
export enum TipoArquivoSearchOrderBy {
    ID = 1,
    Nome = 2,
    Ativo = 3
};
